import * as React from 'react';
import cls from 'classnames';
import './style/index.scss';
/**
 * @author tongxiaokang
 * @version 0.0.1
 *
 * 所有可点击的组件，都可嵌套该组件，为组件提供点击时的 class 与 style
 */
export default class TouchFeedback extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            active: false
        };
        this.onTouchStart = (e) => {
            this.triggerEvent('TouchStart', true, e);
        };
        this.onTouchMove = (e) => {
            this.triggerEvent('TouchMove', false, e);
        };
        this.onTouchEnd = (e) => {
            this.triggerEvent('TouchEnd', false, e);
        };
        this.onTouchCancel = (e) => {
            this.triggerEvent('TouchCancel', false, e);
        };
        this.onMouseDown = (e) => {
            this.triggerEvent('MouseDown', true, e);
        };
        this.onMouseUp = (e) => {
            this.triggerEvent('MouseUp', false, e);
        };
        this.onMouseLeave = (e) => {
            this.triggerEvent('MouseLeave', false, e);
        };
    }
    componentDidUpdate() {
        if (this.props.disabled && this.state.active) {
            this.setState({ active: false });
        }
    }
    triggerEvent(type, isActive, ev) {
        const eventType = `on${type}`;
        const { children } = this.props;
        if (children.props[eventType]) {
            children.props[eventType](ev);
        }
        if (isActive !== this.state.active) {
            this.setState({ active: isActive });
        }
    }
    render() {
        const { children, disabled, activeClassName, activeStyle } = this.props;
        const events = disabled ? undefined : {
            onTouchStart: this.onTouchStart,
            onTouchMove: this.onTouchMove,
            onTouchEnd: this.onTouchEnd,
            onTouchCancel: this.onTouchCancel,
            onMouseDown: this.onMouseDown,
            onMouseUp: this.onMouseUp,
            onMouseLeave: this.onMouseLeave
        };
        const child = React.Children.only(children);
        if (!disabled && this.state.active) {
            let { style, className } = child.props;
            if (activeStyle) {
                style = Object.assign({}, style, activeStyle);
            }
            className = cls(className, activeClassName);
            return React.cloneElement(child, Object.assign({ className, style }, events));
        }
        return React.cloneElement(child, events);
    }
}
TouchFeedback.defaultProps = {
    disabled: false,
    activeClassName: 'x-active'
};
